module.exports = __webpack_public_path__ + "img/udmark-dark.956c74c3.png";